// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDwdj3QdRURhpvlYgdz1D06o0hPdSYcI5E",
  authDomain: "skill-verification-app.firebaseapp.com",
  projectId: "skill-verification-app",
  storageBucket: "skill-verification-app.firebasestorage.app", // Corrected to user-provided value
  messagingSenderId: "301749459374",
  appId: "1:301749459374:web:f4a5070ddd72e37b3e503f",
  measurementId: "G-KLBPLCC3Z3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, analytics };
